import type { SearchCriteria, PartialSearchCriteria } from '../../model/types';

interface FromCityParams {
  fromCity?: number;
}

export function fromCity(criteria: SearchCriteria | PartialSearchCriteria): FromCityParams {
  const city = criteria.fromCity;
  if (city) {
    return { fromCity: city.id };
  }
  return {};
}
